module.exports = {
  businessUnits: {
    FR: {
      brandName: 'iziwork',
      language: 'fr',
      country: 'FR',
      filterCountriesIso3Codes: ['FRA'],
      iframe: false,
      paths: {
        jobOffer: 'offre-emploi',
        apply: 'postuler',
        cities: 'villes',
        sectors: 'secteurs',
        jobs: 'metiers',
        painPoints: 'pain-points',
        solutions: 'solutions',
        sitemap: 'sitemap',
      },
      links: {
        apple_store: 'https://apps.apple.com/fr/app/iziwork-offres-demploi/id1446760096?l=fr&ls=1',
        google_store: 'https://play.google.com/store/apps/details?id=abeka.iziwork&hl=fr&gl=fr',
      },
      currency: 'EUR',
      distanceUnit: 'km',
      metaImage: 'meta-image-fr.jpeg',
      isProman: false,
    },
    IT: {
      brandName: 'iziwork',
      language: 'it',
      country: 'IT',
      filterCountriesIso3Codes: ['ITA'],
      iframe: false,
      paths: {
        jobOffer: 'offerta-lavoro',
        apply: 'candidati',
        cities: 'citta',
        sectors: 'settori',
        jobs: 'professioni',
        painPoints: 'pain-points',
        solutions: 'solutions',
        sitemap: 'sitemap',
      },
      links: {
        apple_store: 'https://apps.apple.com/it/app/iziwork-offres-demploi/id1446760096?l=it&ls=1',
        google_store: 'https://play.google.com/store/apps/details?id=abeka.iziwork&hl=it&gl=it',
      },
      currency: 'EUR',
      distanceUnit: 'km',
      metaImage: 'meta-image-it.jpeg',
      isProman: false,
    },
    PM: {
      brandName: 'Proman Solutions',
      language: 'fr',
      country: 'FR',
      filterCountriesIso3Codes: ['FRA'],
      iframe: false,
      paths: {
        jobOffer: 'offre-emploi',
        apply: 'postuler',
        cities: 'cities',
        sectors: 'sectors',
        jobs: 'jobs',
        painPoints: 'pain-points',
        solutions: 'solutions',
        sitemap: 'sitemap',
      },
      links: {
        apple_store: 'https://apps.apple.com/fr/app/proman-solutions/id6758336033',
        google_store: 'https://play.google.com/store/apps/details?id=fr.proman.interim',
      },
      currency: 'EUR',
      distanceUnit: 'km',
      metaImage: 'meta-image-pm.jpeg',
      isProman: true,
    },
    PSTF: {
      brandName: 'Proman Staffing',
      language: 'en',
      country: 'US',
      filterCountriesIso3Codes: ['USA'],
      iframe: true,
      paths: {
        jobOffer: 'job-offer',
        apply: 'apply',
        cities: 'cities',
        sectors: 'sectors',
        jobs: 'jobs',
        painPoints: 'pain-points',
        solutions: 'solutions',
        sitemap: 'sitemap',
      },
      links: {
        apple_store: 'https://apps.apple.com/en/app/proman-staffing/id6753673111',
        google_store: 'https://play.google.com/store/apps/details?id=com.promanstaffingus',
      },
      currency: 'USD',
      distanceUnit: 'mi',
      metaImage: 'meta-image-us.jpeg',
      isProman: true,
    },
  },
};
